import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import { ProtocolItemHttpEditRequestModel } from '../httpQueue/protocolItem/types';
import { ProtocolItemOutDto } from 'shared/dtos/out/protocolItem';

export class ProtocolItemEditor {
  constructor(
    private addRequest: (
      request: ProtocolItemHttpEditRequestModel
    ) => Promise<any>
  ) {}

  async execute(
    inspectionId: string,
    protocolItemId: string,
    protocolItemOutDto: ProtocolItemOutDto,
    uniqueId: string,
    projectId: string
  ): Promise<void> {
    debugLog(
      'ProtocolItemEditor',
      inspectionId,
      protocolItemId,
      protocolItemOutDto
    );
    const request: ProtocolItemHttpEditRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        inspectionId,
        protocolItemId,
        protocolItemOutDto,
        uniqueId,
        projectId,
      },
      entityType: HttpRequestModelType.protocolItem,
      status: HttpRequestStatus.NEW,
      url: `/project/${projectId}/inspection/${inspectionId}/protocolItem/${protocolItemId}`,
    };

    await this.addRequest(request);
  }
}

export const protocolItemEditor = new ProtocolItemEditor(addRequest);
